<template>
    <div class="contact">
        <div class="code">
            <img src="@/assets/contact/chat.png" />
        </div>

        <!-- 谷歌地图 -->
        <!-- <gmap-map
            :center="{ lng: 114.167762, lat: 22.286977 }"
            :zoom="15"
            style="width: 100%; height: 100%"
        ></gmap-map> -->
        <!-- 地图 -->
        <div class="map">
            <baidu-map
                class="bm-view"
                :center="{ lng: 114.167762, lat: 22.286977 }"
                :zoom="15"
            >
                <bm-marker
                    :position="{ lng: 114.167762, lat: 22.286977 }"
                    :dragging="true"
                    animation="BMAP_ANIMATION_BOUNCE"
                >
                    <bm-navigation
                        anchor="BMAP_ANCHOR_TOP_RIGHT"
                    ></bm-navigation>
                </bm-marker>
            </baidu-map>
        </div>

        <bottom></bottom>
    </div>
</template>

<script>
import bottom from '@/components/bottom.vue'
export default {
    components: {
        bottom
    }
}
</script>

<style lang="less" scoped>
.contact {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .code {
        width: 1036px; //86vw;
        img {
            width: 100%;
        }
    }
    .map {
        width: 1036px; //86vw;
        height: 600px;
        margin-top: 4vh;
        margin-bottom: 4vh;
        .bm-view {
            width: 100%;
            height: 100%;
        }
    }
}
@media screen and (max-width: 1042px) {
    .code {
        width: 86vw !important;
    }
    .map {
        width: 86vw !important;
        height: 400px !important;
    }
}
</style>